<a (click)="reset()">{{ rootLabel }}</a>
@for (value of selectedValues; track value; let i = $index; let isLast = $last) {
  @if (isLast) {
    <span (click)="clickBreadcrumb(i - 1)" class="breadcrumb-filter--mobile">&lt;</span>
  }
  <span class="separator"></span>
  <a (click)="clickBreadcrumb(i)">{{ getLabel(value, i) }}</a>
}
